import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { Money } from '../model/money';

export class MoneyValidator {
  static moneyMin(minAmount: number | Money): ValidatorFn {
    return (c: AbstractControl) => {
      let amount = MoneyValidator.toNumeric(c.value);
      if (amount === null || amount >= MoneyValidator.toNumeric(minAmount)) return null;

      let error = {};
      error[MoneyValidator.getControlName(c)] = { message: 'ERROR.MIN_AMOUNT', params: { 0: minAmount } };
      return error;
    };
  }

  static required(): ValidatorFn {
    return (c: AbstractControl) => {
      if (c.value === null || c.value.amount === null) {
        let error = {};
        error[MoneyValidator.getControlName(c)] = { message: 'ERROR.REQUIRED' };
        return error;
      }
      return null;
    };
  }

  static moneyMax(maxAmount: number | Money): ValidatorFn {
    return (c: AbstractControl) => {
      let amount = MoneyValidator.toNumeric(c.value);
      if (amount === null || amount <= MoneyValidator.toNumeric(maxAmount)) return null;

      let error = {};
      error[MoneyValidator.getControlName(c)] = { message: 'ERROR.MAX_AMOUNT', params: { 0: maxAmount } };
      return error;
    };
  }

  private static toNumeric(amount: number | Money) {
    if (typeof amount === 'number') return amount;
    if (!amount) return null;
    return amount.amount;
  }

  static moneyBetween(minAmount: number | Money, maxAmount: number | Money): ValidatorFn {
    return Validators.compose([MoneyValidator.moneyMin(minAmount), MoneyValidator.moneyMax(maxAmount)]);
  }

  static getControlName(c: AbstractControl): string | null {
    if (c.parent === null) return 'x';
    const formGroup = c.parent.controls;
    return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
  }
}
